import { render, staticRenderFns } from "./SolusiGuru.vue?vue&type=template&id=234771e5&"
import script from "./SolusiGuru.vue?vue&type=script&lang=js&"
export * from "./SolusiGuru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports